import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CreateOrEditEventTypeDto, EventTypesServiceProxy, CreateOrEditCategoryDto, EventDto, GetPendingTransfersForEditOutput, EventsServiceProxy, TransferRegistrationsDto } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'adjustDeadlineForPublishModal',
    templateUrl: './adjust-deadline-for-publish-modal.component.html'
})

export class AdjustDeadlineForPublishModalComponent extends AppComponentBase {

    @ViewChild('adjustModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    event: EventDto = new EventDto();
    transfersForEditModel: GetPendingTransfersForEditOutput = new GetPendingTransfersForEditOutput();

    constructor(
        injector: Injector,
        private _eventsService: EventsServiceProxy
    ) {
        super(injector);
        this.initializeAdjuste();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }    

    initializeAdjuste(): void {
        this.event = new EventDto();
        this.transfersForEditModel = new GetPendingTransfersForEditOutput();
    }

    public show(event: EventDto, transfersForEditModel: GetPendingTransfersForEditOutput): void {        
        
        this.initializeAdjuste();
        this.event = event;
        this.transfersForEditModel = transfersForEditModel;

        this.active = true;
        this.modal.show();
    }    

    save(): void {
        
        let model = new TransferRegistrationsDto();        
        model.publish = true;
        model.eventId = this.event.id;
        model.registrationsToTransfer = this.transfersForEditModel.registrationsToTransfer;

        this._eventsService.transferRegistrationsToNextEvent(model)
            .finally(() => { this.saving = false; })
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/events/modals/adjust-deadline-for-publish/adjust-deadline-for-publish-modal.component.ts